// File: frontend/src/components/common/Spinner.js

import React from 'react';
import './Spinner.css'; // Hum iske liye ek CSS file banayenge

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-container"></div>
      <p>Loading...</p>
    </div>
  );
};

export default Spinner;